import './front.scss';
import { FlippableCardsFront } from './FlippableCardsFront.js';

new FlippableCardsFront( document ).init();
